import React from 'react';
import styled from 'styled-components';
import { themes } from 'kb-shared';
import ProfileForm from './components/ProfileForm';

function MyProfile() {
  return (
    <Container>
      <FormContainer>
        <Title>My profile</Title>
        <DescriptionText>
          This is the profile information we currently have on file for you.
        </DescriptionText>
        <AdditionalInformation>All changes are automatically saved.</AdditionalInformation>
        <ProfileForm />
      </FormContainer>
    </Container>
  );
}

const Container = styled.div`
  ${({ theme }) => theme.grid.pageContainer};
  margin-top: 100px;
  width: 80%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const FormContainer = styled.div`
  max-width: 750px;
`;

const Title = styled.h1`
  ${({ theme }) => theme.typos.pageHeader};
  margin: 30px 0;
`;

const DescriptionText = styled.p`
  ${themes.fonts.FoundersGrotesk};
  color: ${themes.colors.KBNight};
  white-space: pre-wrap;
`;

const AdditionalInformation = styled.p`
  ${themes.fonts.FoundersGrotesk};
  color: ${themes.colors.KBNight};
  margin: 4px 0 60px 0;
  font-weight: bold;
`;

export default MyProfile;
